import * as React from "react";
const SvgAddLine = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z" }));
export default SvgAddLine;
